import React from "react";
import PageTitle from "../../components/PageTitle";
import './Links.css';
import { RiTwitterXFill } from 'react-icons/ri';
import { SiBluesky } from 'react-icons/si';
import { FaInstagram , FaYoutube } from "react-icons/fa";

const Links = () => {
  return (
    <div>
		<div className="Links-page-wrapper" />
		<PageTitle title={"Links"} />

		<h1 className="top-title">Links</h1>

		<div className="message-area">
			<p>当ホームページはリンクフリーです。<br/>
			リンクを貼っていただける場合は、以下のバナーをご利用下さい。<br/><br/>
			リンク先 : https://adzuki-world.com/<br/>
			</p>
			<div className="my_banner">
				<p>
					<span>200×40px</span>
					<img src="links/banner/banner_200x40.png" alt="200x40" />
				</p>
				<p>
					<span>400×80px</span>
					<img src="links/banner/banner_400x80.png" alt="400x80" />
				</p>
			</div>
		</div>

		<h2>My Link</h2>
		<p>Adzuki.が管理している外部サービスです。</p>
		<div className="Service_banner">
			<a href="https://x.com/a_d_z_u_k_i_" target="_blank" rel="noreferrer" title="X"><p><RiTwitterXFill /></p></a>
			<a href="https://bsky.app/profile/adzuki0324.bsky.social" target="_blank" rel="noreferrer" title="Bluesky"><p><SiBluesky/>　Bluesky</p></a>
			<a href="https://www.instagram.com/adzuki0324/" target="_blank" rel="noreferrer" title="Instagram"><p><FaInstagram/>　Instagram</p></a>
			<a href="https://mixi.social/@adzuki0324" target="_blank" rel="noreferrer" title="mixi2"><p>mixi2</p></a>
			<a href="https://wick-sns.com/sns/profile/b4957189-4c96-4574-bcbc-8d61805aef26" target="_blank" rel="noreferrer" title="wick"><p>wick</p></a>
			<a href="https://www.pixiv.net/users/13909150" target="_blank" rel="noreferrer" title="Pixiv"><p><img src="links/mylink/pixiv.svg" alt="Pixiv" /></p></a>
			<a href="https://www.youtube.com/channel/UCG2tjEepAc13Tf9cQEVsyiQ" target="_blank" rel="noreferrer" title="YouTube"><p><FaYoutube/>　YouTube</p></a>
			<a href="https://charaforio.com/ja/user/adzuki0324" target="_blank" rel="noreferrer" title="Charaforio"><p>Charaforio</p></a>
			<a href="https://portal.circle.ms/Circle/Index/10478328" target="_blank" rel="noreferrer" title="Circle.ms"><p>Circle.ms</p></a>
			<a href="https://hitori-yogari.booth.pm/" target="_blank" rel="noreferrer" title="BOOTH"><p>BOOTH</p></a>
			<a href="https://store.line.me/stickershop/author/124928/" target="_blank" rel="noreferrer" title="LINEクリエイターページ"><p>LINEクリエイターページ</p></a>
			<a href="https://www.ac-illust.com/main/profile.php?id=24386584" target="_blank" rel="noreferrer" title="イラストAC"><p>イラストAC</p></a>
			<a href="https://sugbt.adzuki-world.com/" target="_blank" rel="noreferrer" title="シュガビタエブリデイズ 公式サイト"><p>シュガビタエブリデイズ</p></a>
		</div>

		<h2>Request</h2>
		<p>Adzuki.にご依頼したい時に。</p>
		<div className="Service_banner">
			<a href="https://skeb.jp/@a_d_z_u_k_i_" target="_blank" rel="noreferrer" title="Skeb"><p>Skeb</p></a>
			<a href="https://www.pixiv.net/users/13909150/request" target="_blank" rel="noreferrer" title="Pixiv Request"><p>Pixiv Request</p></a>
			<a href="https://skima.jp/profile?id=515371" target="_blank" rel="noreferrer" title="SKIMA"><p>SKIMA</p></a>
		</div>



		<h2>Favorite Link</h2>
		<p>相互リンク先も含みます。</p>
		<div className="Links_banner">
			<a href="https://kanoguti93.neocities.org/" target="_blank" rel="noreferrer" title={"Kanoguti-@rt-Project - Kanogutiさんのサイトです。\n前衛的なゲーム作品、音楽、絵等を制作されています。"}><img src="links/fav/kap.gif" alt="K-@-P"></img></a>
			<a href="https://kosai630.com/" target="_blank" rel="noreferrer" title={"ムカデの住処 - Centipede630 Kosaiさんのサイトです。\n素敵な音楽、ゲーム作品、イラストを制作されてます。"}><img src="links/fav/kosai630.png" alt="ムカデの住処"></img></a>
			<a href="https://dekoco.net/" target="_blank" rel="noreferrer" title={"シロデココ - デココさんのサイトです。\n「カシカッシー」という創作をされています。"}><img src="links/fav/shirodekoco.png" alt="シロデココ"></img></a>
			<a href="https://cottonwind.com/" target="_blank" rel="noreferrer" title={"こっとんうぃんど - わたかぜコウさんのサイトです。\n「わたかぜの里の物語」という創作をされています。"}><img src="links/fav/cottonwind.webp" alt="こっとんうぃんど"></img></a>
			<a href="https://pohemochi.wixsite.com/hoshigumo" target="_blank" rel="noreferrer" title={"hosigumo - ぽへもちさんのポートフォリオサイトです。"}><p>hoshigumo</p></a>
			<a href="https://copocota.com/" target="_blank" rel="noreferrer" title={"こぽこたサイト - こぽこたさんのサイトです。\n「サークルAir-C」として活動してらっしゃいます。"}><p>こぽこたサイト</p></a>
		
		</div>

		<h2>Event</h2>
		<p>Adzuki.が出没したことがある同人即売会等です。</p>
		<div className="Links_banner">
			<a href="https://skypalette.jp/kemoket/" target="_blank" rel="noreferrer" title="けもケット"><img src="links/events/kemoket.png" alt="けもケット"></img></a>
			<a href="https://www.hihumidoujin.net/" target="_blank" rel="noreferrer" title="ひぃふぅみぃ!!"><img src="links/events/hihumi.png" alt="ひぃふぅみぃ!!"></img></a>
			<a href="https://flip-furry.jp/" target="_blank" rel="noreferrer" title="FLiP"><p>FLiP</p></a>
			<a href="https://www.comitia.co.jp/" target="_blank" rel="noreferrer" title="COMITIA"><img src="links/events/comitia.png" alt="COMITIA"></img></a>
			<a href="https://elysian.dojin.com/h-comitia/" target="_blank" rel="noreferrer" title="北海道COMITIA"><img src="links/events/hokkaidocomitia.jpg" alt="北海道COMITIA"></img></a>
		</div>

		{/*
		<h2>Search Engine</h2>
		<p>当HPを登録している検索サーチサイトです。</p>
		*/}

		

	</div>
  );
};

export default Links;